import { useQuery } from '@tanstack/react-query';
import { useApiClient } from './useApiClient';
import type { FlowDataPoint } from './useMeterFlow';
import { isRetryableApiError } from '../lib/classicFlow';

interface MeterClassicFlowResponse {
  flow: FlowDataPoint[];
}

export function useMeterClassicFlow(
  sensorId: string | undefined,
  dateRange?: { from: Date; to: Date },
) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['meter-classic-flow', sensorId, dateRange?.from, dateRange?.to],
    queryFn: () => {
      const params = dateRange
        ? `?start=${dateRange.from.toISOString()}&end=${dateRange.to.toISOString()}`
        : '';
      return apiClient.get<MeterClassicFlowResponse>(`meters/${sensorId}/classic-flow${params}`);
    },
    enabled: !!sensorId,
    // One retry, and only for network errors and 5xx: auth failures and other
    // 4xx (including a meter missing from Classic) are definitive.
    retry: (failureCount, error) => isRetryableApiError(error) && failureCount < 1,
  });
}
